import { AfterViewInit, Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { LayerItemComponent } from "../layer-item/layer-item.component";
import { IProjectAOI } from "../../interfaces/i-project-aoi";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-project-layer-item",
  templateUrl: "./project-layer-item.component.html",
  styleUrls: ["./project-layer-item.component.scss"],
  standalone: false,
})
export class ProjectLayerItemComponent extends LayerItemComponent implements AfterViewInit {
  rightLayer: boolean = false;

  singleViewToolTip = "Currently viewing on the map";

  rightViewToolTip = "Currently viewing on the right-side map";

  leftViewToolTip = "Currently viewing on the left-side map";

  bothViewToolTip = "Currently viewing on both sides of the map";

  toolTip: string = null;

  @Input()
  set selectedAOIS(value: IProjectAOI[]) {
    this._selectedAOIS = value;
    // this.checksSelectedAOI();
  }

  get selectedAOIS(): IProjectAOI[] {
    return this._selectedAOIS;
  }

  private _selectedAOI: boolean = false;

  get selectedAOI(): boolean {
    return this._selectedAOI;
  }

  set selectedAOI(value: boolean) {
    this._selectedAOI = value;
    if (value) this.extentParentEvent.emit(true);
  }

  ngAfterViewInit() {
    this.checksSelectedAOI();
  }

  checksSelectedAOI(): void {
    let selectedLayer = null;
    if (this.layer) {
      if (this.layer.aois?.length && !this.showChilds()) {
        selectedLayer = this.selectedAOIS.find(
          (selectedAOI) => !!selectedAOI && selectedAOI.getCollectionId().toString() === this.layer.id.toString(),
        );
      } else {
        selectedLayer = this.selectedAOIS.find(
          (selectedAOI) => !!selectedAOI && selectedAOI.getLayerId().toString() === this.layer.id.toString(),
        );
      }
    }

    this.rightLayer =
      this.selectedAOIS && this.selectedAOIS[1] && selectedLayer && this.selectedAOIS[1].name === selectedLayer.name;

    if (selectedLayer) {
      if (this.selectedAOIS && this.selectedAOIS.length === 1) {
        this.toolTip = this.singleViewToolTip;
      } else if (
        this.selectedAOIS &&
        this.selectedAOIS.length === 2 &&
        ((!this.showChilds() && this.selectedAOIS[0].getCollectionId() === this.selectedAOIS[1].getCollectionId()) ||
          this.selectedAOIS[0].name === this.selectedAOIS[1].name)
      ) {
        this.toolTip = this.bothViewToolTip;
      } else if (this.rightLayer) {
        this.toolTip = this.rightViewToolTip;
      } else {
        this.toolTip = this.leftViewToolTip;
      }
    }

    this.selectedAOI = !!selectedLayer;
  }
}
